import { render, staticRenderFns } from "./tab6.vue?vue&type=template&id=29693662&scoped=true&"
import script from "./tab6.vue?vue&type=script&lang=js&"
export * from "./tab6.vue?vue&type=script&lang=js&"
import style0 from "./tab6.vue?vue&type=style&index=0&id=29693662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29693662",
  null
  
)

export default component.exports